module.exports = __webpack_public_path__ + "static/media/T12_headboard Finishing_Vintage Eco Leather_White.4da83cca.png";